import { StyleSheet } from 'aphrodite';

export const medicareProColor = '#010E35';

export const styleSheet = StyleSheet.create({
	ctaButton: {
		boxShadow: 'none',
		color: medicareProColor,
		marginTop: 20,
		border: `1px solid ${medicareProColor}`,
	},
	integrationTitle: {
		color: medicareProColor,
	},
	graphic: {
		display: 'block',
		maxWidth: 200,
		marginBottom: 16,
	},
	integrationGraphic: {
		display: 'block',
		':nth-child(1n) > svg': {
			height: 'auto',
			width: 180,
		},
	},
});
